import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { LabelSetting } from "../../../i18n/locale-helper"
import moduleConstant from "../../../common/module-constant";
import { CONSTRUCTION_TYPE, HISTORY_MODES, ROUTER } from "../../../common/constants";
import { ROUTER_HELPER } from "../../../common/router-helper.contstants";
import { namespace, Mutation, Getter } from "vuex-class";
import { storeModules } from "../../../store";
import { IDrawerModel, DrawerModel } from "../../../models/common/drawer.model";
import { DRAWER_NAME } from "../../../common/drawer-component.constants";
import { IAuthConfigModel } from "../../../models/user/auth-config.model";
import { IAudioPlayerState } from "../../../store/audio-player/audio-player-types.store";
import { HistoryServices } from "../../../services";
import fileUriConstants from "../../../common/uri/file-uri.constants";
import axios from "axios";
import EventBus from "../../../utils/event-bus";
import { generateNewTabId } from "../../../utils/cached-data";

const CALL_MARKER = '--CALL:';

const CommonMutation = namespace(storeModules.Common, Mutation);
const UserGetter = namespace(storeModules.User, Getter);
const AudioPlayerMutation = namespace(storeModules.AudioPlayer, Mutation);
const AudioPlayerGetter = namespace(storeModules.AudioPlayer, Getter);

@Component({
    template: require("./template.html"),
    components: {
        'email-out': () => import("../../../containers/history/email-out/EmailOutComponent.vue")
    }
})
class TimeLineComponent extends Vue {
	@Prop()
	data: any[];

	@Prop()
	isLoading: boolean;

	@Prop({ default: null })
	scrollbarOffset: number;

	@Prop({ default: false })
	isAgenda: boolean;

	@Prop({ default: false })
	isTask: boolean;

	@Prop({ default: true })
	hasScrollbar: boolean;

	@Prop({ default: null })
	fixHeight: number;

	@Prop({ default: 0, type: Number }) moduleType: number;

    @Prop({ default: false, type: [Boolean] }) viewHistory;
    
    @CommonMutation setVisibleDrawerModel: (payload: IDrawerModel) => void;

    @UserGetter authConfig: IAuthConfigModel;

    @AudioPlayerMutation setAudioPlayer: (payload: IAudioPlayerState) => void;
    @AudioPlayerGetter recordId: () => number;
    @AudioPlayerGetter isShow: () => boolean;
    @AudioPlayerGetter isPlaying: () => boolean;

    private historyServices: HistoryServices = new HistoryServices();

    currentData: any = [];
	historyModalModuleType: number = null;
    historyModalId: number = null;
    
    visibleEmailOut: boolean = false;
    selectedEmailOut = null;

	get coModuleType() {
		return this.moduleType;
	}

	get lblGlobal() {
		return LabelSetting.Global;
	}

	get lblProperty() {
		return LabelSetting.Property;
    }
    
    get IsAllowDeleteHistory() {
        return this.authConfig && this.authConfig.Config && this.authConfig.Config.IsAllowDeleteHistory;
    }

    numberOfEnableActions(item) {
        let size = 0;
        const isShowEmailOut = this.isShowEmailOut(item);
        const isAllowDeleteHistory = this.IsAllowDeleteHistory;
        const isShowPlayRadioButton = this.isShowPlayRadioButton(item);

        if (isShowEmailOut) {
            size++;
        }

        if (isAllowDeleteHistory) {
            size+= 2;
        }

        if (isShowPlayRadioButton) {
            size+= 3;
        }

        return {size, isShowEmailOut, isAllowDeleteHistory, isShowPlayRadioButton};
    }

    isShowEmailOut(item) {
        if (item.TypeId === 4) return true;
        return false;
    }

    // New system
    isShowPlayRadioButton(item) {
        return item.IsNewSystem && !item.isLoading;
    }

    openEmailOut(item) {
        this.visibleEmailOut = true;
        this.selectedEmailOut = item;
    }

    deleteHistory(record) {
        this.$emit('delete', record);
    }
	
	getDate(date: string) {
		if (!date) return "";

		const d = new Date(date);
        const lang = localStorage.getItem("lang") as any;
        
        if (!lang) return "";
        const formatedDate = Intl.DateTimeFormat(lang, {
			weekday: "long",
			month: "short",
			day: "numeric",
			year: "numeric"
		}).format(d);
		return formatedDate;
	}

	getTime(date: string) {
		if (!date) return "";
        const lang = localStorage.getItem("lang") as any;
        if (!lang) return "";
        return this.$formatDateTimeByLocale(date);
	}

	getHtmlText(str) {
		if (/<[a-z][\s\S]*>/i.test(str)) {
			return str;
		}
		return str.replace(/\n/g, "<br />").replace(/\u21b5/g, "<br />");
	}
	private buildHistoryModalParams(data) {
		this.historyModalModuleType = this.coModuleType;
		this.historyModalId = data.RootId;
	}
	openHistory(item) {
		switch(item.Type) {
			case HISTORY_MODES.HISTORY:
                this.buildHistoryModalParams(item);
                this.setVisibleDrawerModel(new DrawerModel({
                    componentName: DRAWER_NAME.HISTORY_MODAL,
                    props: {
                        id: this.historyModalId,
                        type: 1,
                        showViewPerson: true,
                        moduleType: this.historyModalModuleType,
                    },
                    title: 'HISTORYDETAIL',
                    showSaveBtn: true
                }))
				break;
			case HISTORY_MODES.AGENDA:
				const routeName = item.AppointmentIsRecurrence && !item.AppointmentIsException ?
					ROUTER.AGENDA.AGENDA_EDIT_SERIES
					: ROUTER.AGENDA.AGENDA_EDIT
				this.$router.push({
					name: routeName,
					params: {
						id: item.RootId.toString()
					}
				})
				break;
			case HISTORY_MODES.TASK:
				this.$router.push({
					name: ROUTER.TASK.TASK_EDIT,
					params: {
						id: item.RootId.toString()
					}
				})
				break;
			default:
				break;
		}
	}

	public getTypeHistory() {
		switch (this.coModuleType) {
			case moduleConstant.Object:
			case moduleConstant.Project:
				return { type: ROUTER_HELPER.TYPE.PROPERTY, action: ROUTER_HELPER.ACTION.VIEW };
			case moduleConstant.Demand:
				return { type: ROUTER_HELPER.TYPE.DEMAND, action: ROUTER_HELPER.ACTION.VIEW };
			case moduleConstant.Person:
				return { type: ROUTER_HELPER.TYPE.CLIENT, action: ROUTER_HELPER.ACTION.VIEW };
			default:
				return { type: ROUTER_HELPER.TYPE.HISTORY, action: ROUTER_HELPER.ACTION.VIEW };
		}
    }
    
    handleOpenPersonDetail(record) {
        let param = {
            componentName: DRAWER_NAME.PERSON_DETAIL,
            props: {
                objectId: record.Id,
            },
            title: 'PERSON'
        }
        switch (this.coModuleType) {
            case moduleConstant.Object:
                param.componentName = DRAWER_NAME.PERSON_DETAIL;
                param.props.objectId = record.ChildId
                param.title = 'PERSON'
                break;
            case moduleConstant.Project:
                param.componentName = DRAWER_NAME.PERSON_DETAIL;
                param.props.objectId = record.ChildId
                param.title = 'PERSON'
                break
            case moduleConstant.Demand:
                param.componentName = DRAWER_NAME.PERSON_DETAIL;
                param.props.objectId = record.Id
                param.title = 'PERSON'
                break
            case moduleConstant.Person:
                param.componentName = DRAWER_NAME.PERSON_DETAIL;
                param.props.objectId = record.ChildId
                param.title = 'PERSON'
                break
            default:
                break;
        }

            this.setVisibleDrawerModel(new DrawerModel(param))
    }

    handleOpenPropertyDetail(record) {
        // a project's shadow record opens the project drawer directly (SWA-7477);
        // records without construction info fall back to the property drawer, which redirects itself
        if (record.PropertyConstructionType === CONSTRUCTION_TYPE.Project && record.ProjectId > 0) {
            this.setVisibleDrawerModel(new DrawerModel({
                componentName: DRAWER_NAME.PROJECT_DETAIL,
                props: {
                    objectId: record.ProjectId,
                },
                title: 'PROJECT',
            }));
            return;
        }

        let param = {
            componentName: DRAWER_NAME.PROPERTY_DETAIL,
            props: {
                objectId: record.Id,
            },
            title: 'PROPERTY'
        }
        switch (this.coModuleType) {
            case moduleConstant.Object:
                param.componentName = DRAWER_NAME.PROPERTY_DETAIL;
                param.props.objectId = record.Id
                param.title = 'PROPERTY'
                break;
            case moduleConstant.Project:
                param.componentName = DRAWER_NAME.PROPERTY_DETAIL;
                param.props.objectId = record.Id
                param.title = 'PROPERTY'
                break
            case moduleConstant.Demand:
                param.componentName = DRAWER_NAME.PROPERTY_DETAIL;
                param.props.objectId = record.ChildId
                param.title = 'PROPERTY'
                break
            case moduleConstant.Person:
                param.componentName = DRAWER_NAME.PROPERTY_DETAIL;
                param.props.objectId = record.ChildId
                param.title = 'PROPERTY'
                break
            default:
                break;
        }
        this.setVisibleDrawerModel(new DrawerModel(param));
    }

	get isViewHistory() {
		return true;
    }

    openHistoryByAppLink() {
        const {type, historyId} = this.$route.params;
        const item = {
            id: parseInt(historyId),
        }

        this.setVisibleDrawerModel(new DrawerModel({
            componentName: DRAWER_NAME.HISTORY_MODAL,
            props: {
                id: item.id,
                type: 1,
                showViewPerson: true,
                moduleType: parseInt(type),
            },
            title: 'HISTORYDETAIL',
            showSaveBtn: true
        }))
    }

    getDocument(documentName) {
		let path = fileUriConstants.getPublishDocumentLink.replace(
			":fileName",
			documentName
		);

		return path;
	}

    isPlayingAudio(record) {
        return this.isShow && this.recordId === record.RootId;
    }

	async downloadDocumentFile(documentName) {
		const publicLink = this.getDocument(documentName);
		const response = await axios.get(publicLink)
        return response.data.data.URL
	}

    async handleOpenAudioPlayer(record): Promise<boolean> {
        if (this.isPlayingAudio(record) && this.isShow) {
            if (this.isPlaying) {
                EventBus.$emit('pauseAudio');
            } else {
                EventBus.$emit('playAudio');
            }

            this.$forceUpdate();
            return true;
        }

        this.$message({
            message: this.$t('PREPARING').toString(),
            type: 'info',
            duration: 2000
        })
        try {
            const response = await this.historyServices.getHistoryById({Id: record.RootId}) as any;
            const filePath = response.data?.FileNames?.[0]?.FilePath;
            const fileName = response.data?.FileNames?.[0]?.Filename;
            if (!filePath) {
                throw new Error('Missing FilePath');
            }
            const audioUrl = await this.downloadDocumentFile(filePath);
            if (!audioUrl) {
                throw new Error('Missing audio URL');
            }

            this.setAudioPlayer({
                audioUrl,
                title: fileName,
                isShow: true,
                recordId: record.RootId
            })
            this.$forceUpdate();
            return true;
        } catch (error) {
            this.$message({
                message: this.$t('FILE_DOWNLOAD_FAILED').toString(),
                type: 'error',
                duration: 2000
            })
            return false;
        }
    }

    async handleOpenCallTranscript(record) {
        this.$message({
            message: this.$t('PREPARING').toString(),
            type: 'info',
            duration: 2000
        })
        try {
            const response = await this.historyServices.getHistoryById({Id: record.RootId}) as any;
            const internalComment = response.data?.History?.InternalComment;
            this.setVisibleDrawerModel(new DrawerModel({
                componentName: DRAWER_NAME.CALL_TRANSCRIPT,
                title: this.$t('CALL_TRANSCRIPT').toString(),
                props: {
                    internalComment: internalComment,
                    record
                }
            }))
        } catch (error) {
            this.$message({
                message: this.$t('FILE_DOWNLOAD_FAILED').toString(),
                type: 'error',
                duration: 2000
            })
        }
    }

    async downloadAudio(record) {
        let blobUrl: string | null = null;
        let link: HTMLAnchorElement | null = null;
        try {
            this.$message({
                message: this.$t('DOWNLOADING').toString(),
                type: 'info',
                duration: 2000
            })
            const response = await this.historyServices.getHistoryById({Id: record.RootId}) as any;
            const filePath = response.data.FileNames?.[0]?.FilePath;
            const fileName = response.data.FileNames?.[0]?.Filename;
            const audioUrl = await this.downloadDocumentFile(filePath);

            const fileResponse = await fetch(audioUrl);
            if (!fileResponse.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await fileResponse.blob();
            blobUrl = window.URL.createObjectURL(blob);

            link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName || 'audio-file.wav';
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            this.$message({
                message: this.$t('FILE_DOWNLOAD_FAILED').toString(),
                type: 'error',
                duration: 2000
            })
        } finally {
            if (link && link.parentNode) {
                document.body.removeChild(link);
            }
            if (blobUrl) {
                window.URL.revokeObjectURL(blobUrl);
            }
        }
    }

    private onTranscriptWordClick = async (record, startAt) => {
        if (this.isPlayingAudio(record)) {
            if (!this.isPlaying) {
                EventBus.$emit('playAudio');
            }
            EventBus.$emit('onProgressChange', startAt);
        } else {
            const opened = await this.handleOpenAudioPlayer(record);
            if (opened) {
                EventBus.$emit('onProgressChange', startAt);
            }
        }
    }

    mounted() {
        const {personId, propertyId, projectId} = this.$route.params;
        if (personId || propertyId || projectId) {
            this.openHistoryByAppLink()
        }

        EventBus.$on('handleClickWordTranscript', this.onTranscriptWordClick);
    }

    async handleNewTask(record) {
        const response = await this.historyServices.getHistoryById({Id: record.RootId}) as any;
        const data = response.data || {};
        const Persons = data.Persons || [];
        const Properties = data.Properties || [];
        const query = {} as any;
        if (Persons.length > 0) {
            query.personId = Persons[0].Id?.toString()
            query.personRef = Persons[0].Reference
        }
        if (Properties.length > 0) {
            query.propertyId = Properties[0].Id?.toString()
            query.propertyRef = Properties[0].Reference
        }
        if (record.TaskTitle) {
            query.searchText = record.TaskTitle
        }

        this.$router.push({
            name: ROUTER.TASK.TASK_NEW,
            query,
            params: {
                id: generateNewTabId(moduleConstant.Task)
            }
        })
    }
    
    shortDescription(description, maxItems = 3) {
        if (!description) return '';

        const lines = description.split('\n').filter(line => line.trim());
        const selectedLines = [];
        let itemCount = 0;

        for (const line of lines) {
            const trimmed = line.trim();
            if (trimmed.match(/^[\*\-\+]\s+/) || trimmed.match(/^\d+\.\s+/) ||
                (trimmed && !trimmed.match(/^#+\s/))) {
                selectedLines.push(line);
                itemCount++;
                if (itemCount >= maxItems) break;
            }
            else if (trimmed.match(/^#+\s/) && selectedLines.length === 0) {
                selectedLines.push(line);
            }
        }

        return selectedLines.join('\n');
    }

    shouldShowToggle(description, maxItems = 2) {
        if (!description) return false;
        
        const lines = description.split('\n').filter(line => line.trim());
        let itemCount = 0;
        
        for (const line of lines) {
            const trimmed = line.trim();
            if (trimmed.match(/^[\*\-\+]\s+/) || trimmed.match(/^\d+\.\s+/) || 
                (trimmed && !trimmed.match(/^#+\s/))) {
                itemCount++;
            }
        }
        
        return itemCount > maxItems;
    }

    isNewSystem(item) {
        return item?.Description?.includes(CALL_MARKER) && item.TypeId === 3;
    }

    changeIsExpanded(index, sIndex) {
        this.currentData[index].children[sIndex].isExpanded = !this.currentData[index].children[sIndex].isExpanded;
        this.$forceUpdate();
    }

    @Watch('data', { immediate: true })
    onDataChange(newVal) {
        if (!newVal) return;
        this.currentData = newVal.map(historyMapper => {
            const mapperClone = { ...historyMapper };
            mapperClone.children = historyMapper.children.map(originalRecord => {
                const record = { ...originalRecord };
                const isNewSystem = this.isNewSystem(record);
                if (isNewSystem && !!record.Description) {
                    let newDescription: any = null;
                    try {
                        newDescription = JSON.parse(record.Description.replace(CALL_MARKER, '').replace(/([{,]\s*)(?!")([a-zA-Z_$][a-zA-Z0-9_$]*)\s*:/g, '$1"$2":'));
                    } catch (e) {
                        return record;
                    }
                    record.Description = newDescription.summary;
                    record.isLoading = !!newDescription.isLoading;
                    record.isDownloading = false;
                    record.isPlaying = false;
                    record.isOpenCallTranscript = false;
                    record.IsNewSystem = true;

                    const maxItemsToShow = 3;
                    record.ShouldShowToggle = this.shouldShowToggle(newDescription.summary, maxItemsToShow);
                    record.ShortDescription = this.shortDescription(newDescription.summary, maxItemsToShow);

                    record.isExpanded = false;
                    record.hasShortDescription = record.ShouldShowToggle && record.ShortDescription && record.ShortDescription.trim() !== '';
                    record.isCollapsed = record.hasShortDescription;
                    if (newDescription.nextAction) {
                        const nextAction = newDescription.nextAction
                        record.NextAction = nextAction;
                        record.Suggestion = nextAction.suggestion;
                        record.TaskTitle = nextAction.taskTitle;
                    }
                }

                const {size, isShowEmailOut, isAllowDeleteHistory, isShowPlayRadioButton} = this.numberOfEnableActions(record);
                record.NumberOfEnableActions = size;
                record.IsShowEmailOut = isShowEmailOut;
                record.IsAllowDeleteHistory = isAllowDeleteHistory;
                record.IsShowPlayRadioButton = isShowPlayRadioButton;

                return record;
            });
            return mapperClone;
        });
    }

    beforeDestroy() {
        EventBus.$off('handleClickWordTranscript', this.onTranscriptWordClick);
    }
}

export default TimeLineComponent;